import { IsTest, getLang } from "@/utils/tools";
import { isHtm } from "@/utils/const";
import { request } from "..";

// TODO 请求域名确定
const testOrigin = "https://test-sg-act.playerinfinite.com/";
const prodOrigin = "https://sg-act.playerinfinite.com/";
const origin = IsTest ? testOrigin : prodOrigin;
interface commomRes {
  code: number;
  msg: string;
  data?: any;
}

export interface RoleInfo{
  area_id: string;
  game_id: number;
  game_name: string;
  plat_id: string;
  role_name: string;
  zone_id: string;
  role_id: string;
}
interface GetSavedRoleInfoRes extends commomRes {
  data: {
    has_saved_role_info: boolean;
    get_saved_role_info: RoleInfo;
    vote_log_list: {
      num: number;
      tag_id: string;
      timestamp: number;
    }
  };
}

export interface Vote {
  num: number;
  tag_id: string
}
interface GetPageVoteNumber extends commomRes {
  data: {
    vote_list:Vote[];
  };
}
const lang_type = getLang();
// @see https://yapi.intlgame.com/project/1344/interface/api/81841
export const getSavedRoleInfo = async () => {
  const otherurl = 'api/flow/Wand-20240531074738-F35aa12f43c7c';
  const htmlurl = 'api/flow/Wand-20240613064432-F2d89efe18c68';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetSavedRoleInfoRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

interface GetRoleInfoReq{
  area_id: string;
}
interface GetRoleInfoRes extends commomRes {
  data: {
    role_list: RoleInfo[];
  };
}

interface VoteParams {
  tag_id: string;
};
// @see https://yapi.intlgame.com/project/1344/interface/api/83796
export const getRoleInfo = async (params: GetRoleInfoReq) => {
  const otherurl = 'api/flow/Wand-20240530021758-F811fd987c67a';
  const htmlurl = 'api/flow/Wand-20240613064614-Fb82e0281a43b';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetRoleInfoRes>(`${origin}${url}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};

type SaveRoleInfoRes = commomRes;
// @see https://yapi.intlgame.com/project/1344/interface/api/83816
export const saveRoleInfo = async (params: Partial<RoleInfo>) => {
  const otherurl = 'api/flow/Wand-20240530021531-F3f2796d33f21';
  const htmlurl = 'api/flow/Wand-20240613064556-F938ef729bb91';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<SaveRoleInfoRes>(`${origin}${url}`, params)
    .then((res) => res.data);
};

export const getVoteNumber = async () => {
  const otherurl = 'api/flow_direct/Wand-20240530021207-F831f1c34d811';
  const htmlurl = 'api/flow_direct/Wand-20240613064732-Fe14cd3221779';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetPageVoteNumber>(`${origin}${url}`,  {
      checkLogin: false,
      needLogin: false,
      lang_type,
    })
    .then((res) => res.data);
};

export const roleVote = async (params: VoteParams) => {
  const otherurl = 'api/flow/Wand-20240530022831-Fc1fde0a7b38d';
  const htmlurl = 'api/flow/Wand-20240613064636-F0c7d0f5d63e7';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params
    })
    .then((res) => res.data);
};

interface  JoinTeamRes extends commomRes{
  data: {
    join_success: boolean;
  }
}
export const joinTeam = async () => {
  const otherurl = 'api/flow/Wand-20240530023404-Fb1d0c7ef4137';
  const htmlurl = 'api/flow/Wand-20240613064650-Fc3fe0edfca80';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<JoinTeamRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};